import React from 'react'
import { arrayOfNums } from '../specCardsHelpers'

const PAGE_SIZE = 50

const PaginationBtn = ({page, isSelected, setPage}) => {
  const gotoPage = () => {
    setPage(page)
  }
  return (<li className={isSelected ? 'selected' : ''}><button className='sml' onClick={gotoPage}>{page+1}</button></li>)
}

const Pagination = ({total, page, pages, setPage}) => {
  let pre = ''
  let suf = ''
  let start = 0
  let end = pages-1

  if (pages > 10) {
    start = page-5
    end = page+5

    if (start < 1) {
      start = 1
      end = 11
    }
    else if (end > pages -2) {
      end = pages - 2
      start = end - 10
    }
       
    pre = <>
    <PaginationBtn page={0} isSelected={page===0} setPage={setPage} />
    {start>1 && <li>...</li>}
    </>

    suf = <>
    {end<pages-2 && <li>...</li>}
    <PaginationBtn page={pages-1} isSelected={page===pages-1} setPage={setPage} />
    </>
  }

  const range = arrayOfNums(start, end)

  let desc = `Showing ${(page*PAGE_SIZE)+1}`
  if (total>1) {
    desc = `${desc} to ${Math.min(total,(page+1)*PAGE_SIZE)}`
  }

  return (
    <ul className='button-list'>
      <li>{desc} of {total} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Page</li>
      {pre}
      {range.map((p) => {
        return (<PaginationBtn page={p} isSelected={page===p} setPage={setPage} />)
      })}
      {suf}
    </ul>
  )
}

export default Pagination
export { PaginationBtn }
